var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-ish',_vm._l((_vm.files),function(file){return _c('table-ish-row',{key:file.uuid},[_c('table-ish-cell',{staticClass:"border-grey-lighter!"},[_c('truncate-hack',[_vm._v("\n                "+_vm._s(file.name)+"\n            ")])],1),_vm._v(" "),_c('table-ish-cell',{staticClass:"text-right border-grey-lighter!",attrs:{"shrink":true}},[_c('laroute-link',{staticClass:"block w-6 h-6",attrs:{"to":{
                    name: 'storage.files.show',
                    params: {
                        file: file.uuid,
                        download: true
                    }
                }}},[_c('base-svg',{staticClass:"w-full h-full",attrs:{"name":"icon-cloud-download"}})],1)],1)],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }